import "quill/dist/quill.snow.css";
import "./styles.css";
import ReactQuill from "react-quill";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const TextAreaWithRichFormatting = (props: Props) => {
  const { value, onChange, placeholder = "Write something..." } = props;

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
  ];

  return (
    <>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />
    </>
  );
};
